import Typekey from './Typekey';

export default class RoleType extends Typekey {
  static readonly userRoleType = new RoleType('user', 'User', '');

  static readonly adminRoleType = new RoleType('admin', 'Admin', '');

  static readonly superAdminRoleType = new RoleType('superadmin', 'Super Admin', '');

  static readonly faculty = new RoleType('faculty', 'Faculty', '');

  static readonly student = new RoleType('student', 'student', '');

  static memberRoles() {
    return [
      RoleType.faculty,
      RoleType.student,
    ];
  }
}
